import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ApprovedOrderRes;
export const ApprovedOrderTodo = createAsyncThunk('ApprovedOrder', async (data) => {
    // console.log("data", data)
    const type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'cart_item_list',
            headers: { "Content-Type": "application/json" },
            data: {
                "item_status": "approved",
                "hod_id": type === 'admin' ? '' : type === 'teacher' ? localStorage.getItem('hod') : '',
                'user_id' : type === 'student' ? localStorage.getItem('user_id') : ''
            }
        })
        return ApprovedOrderRes = res.data

    } catch (error) {
        return ApprovedOrderRes = error.response.data
    }
});

const ApprovedOrderSlice = createSlice({
    name: 'ApprovedOrder',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(ApprovedOrderTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(ApprovedOrderTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default ApprovedOrderSlice.reducer; 